import { Controller } from '@hotwired/stimulus'

export default class extends Controller
{
  static targets = [
    "address",
    "city",
    "state",
    "phone",
    "phoneCountryCode",
    "postalCode",
    "country",
    "statusOfChanges",
    "googleMapsResult"
  ];

  initialize() {
    this.placeChanged = this.placeChanged.bind(this);
  }

  connect() {
    if (typeof google !== "undefined" && google.maps && google.maps.places) {
      this.initAutocomplete();
    }

    if (typeof window.initAddressPhone === 'function') {
      var phoneInput = this.hasPhoneTarget ? this.phoneTarget : null;
      var countryCodeInput = this.hasPhoneCountryCodeTarget ? this.phoneCountryCodeTarget : null;
      window.initAddressPhone(phoneInput, countryCodeInput);
    }

    if (this.countryTarget) {
      // Only restrict Google autocomplete on initial load, not the phone country
      var selectedOption = this.countryTarget.selectedOptions[0];
      if (selectedOption && selectedOption.dataset.code !== undefined) {
        this.restrictCountryGoogle(selectedOption.dataset.code);
      }
      $(this.countryTarget).on('select2:select', function () {
        let event = new Event('change', { bubbles: true }) // fire a native event
        this.dispatchEvent(event);
      });
    }
  }

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.addressTarget, this.autocompleteOptions);
    this.autocomplete.addListener('place_changed', this.placeChanged.bind(this));
  }

  placeChanged() {
    this.place = this.autocomplete.getPlace();
    const addressComponents = this.place.address_components;

    if (addressComponents !== void 0) {
      const formattedAddress = this.formatAddressComponents(addressComponents);
      this.setAddressComponents(formattedAddress);
    }
  }

  setAddressComponents (address) {
    console.log(address);
    if (this.hasCityTarget) this.cityTarget.value = address.locality || "N/A";
    if (this.hasStateTarget) this.stateTarget.value = address.administrative_area_level_1 || "N/A";
    if (this.hasPostalCodeTarget) this.postalCodeTarget.value = address.postal_code || "N/A";
    if (this.hasAddressTarget) {
      let full_address = this.addressTarget.value.split(',');

      if (full_address.length >= 3) {
        full_address.splice(-2);
      }
      else if (full_address.length === 2) {
        if (isNaN(full_address[1])) {
          full_address.splice(-1);
        }
      }

      this.addressTarget.value = full_address;
    }
    if (this.hasStatusOfChangesTarget) this.statusOfChangesTarget.value = 'unchanged';
    if (this.hasGoogleMapsResultTarget) this.googleMapsResultTarget.value = Object.entries(address).map(([key, value]) => `${key}=${value}`).join(';');
  }

  get autocompleteOptions() {
    return {
      fields: ['address_components']
    }
  }

  preventSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
    if (this.hasStatusOfChangesTarget) this.statusOfChangesTarget.value = 'changed';
  }

  formatAddressComponents(addressComponents) {
    const data = {};

    addressComponents.forEach((component) => {
      const type = component.types[0];
      data[type] = component.long_name;
    });

    return data;
  }

  restrictCountry() {
    let country_code = this.countryTarget.selectedOptions[0].dataset.code;

    if (country_code !== undefined) {
      this.restrictCountryGoogle(country_code);
      if (typeof window.iti !== 'undefined' && window.iti) {
        window.iti.setCountry(country_code);
      }
    }
  }

  restrictCountryGoogle(countrycode) {
    if (this.autocomplete && typeof this.autocomplete.setComponentRestrictions === 'function') {
      this.autocomplete.setComponentRestrictions({country: countrycode});
    }
  }

  cleanupForm() {
    if (this.hasCityTarget) this.cityTarget.value = "";
    if (this.hasPhoneTarget) this.phoneTarget.value = "";
    if (this.hasPostalCodeTarget) this.postalCodeTarget.value = "";
    if (this.hasAddressTarget) {
      this.addressTarget.value = "";
      this.addressTarget.focus();
    }
  }
}

// export { GooglePlacesAutocomplete as default };

window.initTest = function () {
  // API library requires callback function to exist.
}


window.initAutocomplete = function(...args) {
  const event = document.createEvent("Events")
  event.initEvent("google-maps-callback", true, true)
  event.args = args
  window.dispatchEvent(event)
}
